import { Pipe, PipeTransform } from '@angular/core';
import { VorgangsTyp } from '../../domain/model/vorgangsTyp';

@Pipe({
    name: 'aufgabeTypeImage',
    standalone: false,
})
export class AufgabeTypeImagePipe implements PipeTransform {

    transform(value: any): any {
        switch (value) {
            case VorgangsTyp.AUFGABE: return 'alarm';
            case VorgangsTyp.INFORMATION: return 'alarm';
            case VorgangsTyp.TERMIN: return 'today';
            case VorgangsTyp.GESAMTLAST: return 'today';
            case VorgangsTyp.ABWURFPUNKTE_AUFGABE: return 'today';
            case VorgangsTyp.ABWURFPUNKTE_INFORMATION: return 'today';
            default: return 'Unbekannter Aufgabentyp';
        }
    }

}
